import { capitalizeWords } from "@/app/(site)/_utils/misc"
import { SHIPPING_COUNTRIES } from "@/data/shipping-countries"
import { SHIPPING_COUNTRY_CODES } from "@/data/shipping-country-code"
import { CENTRA_LANGUAGE_CODE } from "@/data/supported-languages"
import { CENTRA_MARKET_CODE } from "@/data/supported-markets"
import { CENTRA_PRICELIST_CODE } from "@/data/supported-pricelists"
import { RequiredTokenAndSelectionMetadata } from "@/types/cookie-types"

export const emptyTokenAndSelectionMetadata: RequiredTokenAndSelectionMetadata = {
    token: "",
    metadata: {
        market: CENTRA_MARKET_CODE.Eu,
        language: CENTRA_LANGUAGE_CODE.En,
        currency: CENTRA_PRICELIST_CODE.eur.toLocaleUpperCase(),
        country: {
            code: SHIPPING_COUNTRY_CODES.Germany.toLocaleUpperCase(),
            name: capitalizeWords(SHIPPING_COUNTRIES.Germany)
        },
        currencyFormat: {
            name: "",
            prefix: "",
            suffix: "",
            decimalPoint: "",
            thousandsSeparator: "",
            decimalDigits: "",
            uri: ""
        }
    }
}
